import { useEffect, useState } from 'react';
import Button from 'style-guide/Button';
import CheckBox from 'style-guide/CheckBox';
import { CircleArrow, CopyOutlined } from 'style-guide/Icons';
import { Input } from 'style-guide/Input';
import { message } from 'style-guide/ToastMessages';
import Text from 'style-guide/Typography/Text';
import { generateSecureString } from '../helpers';
import SignUpGeneratePassModalWrapper from './style/SignUpGeneratePassModalWrapper';

const SignUpGeneratePassModal = ({ params, hideModal }) => {
  const [checked, setChecked] = useState(false);
  const [password, setPassword] = useState('');

  useEffect(() => {
    setPassword(params?.password);
  }, [params]);

  const copyGeneratedPassword = () => {
    navigator.clipboard
      .writeText(password)
      .then(() => {
        message.success('Password copied!');
      })
      .catch((error) => {
        message.error(error.message);
      });
  };

  return (
    <SignUpGeneratePassModalWrapper>
      <Button variant='link' $block onClick={copyGeneratedPassword} className='copy-button p--0 m--0'>
        <Input className='generated-input' value={password} readOnly />
        <CopyOutlined className='copy-icon' />
      </Button>
      <Button
        className='generate-button justify-content-start pl--0 mb--16'
        variant='link'
        type='button'
        prefix={<CircleArrow width={14} height={14} />}
        onClick={() => setPassword(generateSecureString())}
      >
        Generate new
      </Button>
      <Text className='d-block secure-message mb--16' $variant={2}>
        Please save this password securely. You will need it to log in to your account.
      </Text>
      <div className='d-flex align-items-center mb--24'>
        <CheckBox
          checked={checked}
          onChange={() => {
            setChecked(!checked);
          }}
          className='mr--8'
        />
        <Button className='p--0' variant='link' type='button' onClick={() => setChecked(!checked)}>
          <Text className='mt--2'>I confirm that I have saved this password</Text>
        </Button>
      </div>
      <div className='d-flex justify-content-end'>
        <Button className='mr--8 cancel-button' onClick={() => hideModal()}>
          Cancel
        </Button>
        <Button
          variant='primary'
          disabled={!checked}
          onClick={() => {
            params.setValue('password', password, { shouldValidate: true, shouldTouch: true, shouldDirty: true });
            params.setValue('confirmPassword', password, {
              shouldValidate: true,
              shouldTouch: true,
              shouldDirty: true,
            });
            hideModal();
          }}
        >
          Use password
        </Button>
      </div>
    </SignUpGeneratePassModalWrapper>
  );
};

export default SignUpGeneratePassModal;
